import {
  ValidationErrorWrapper,
  ValidationErrorTitle,
  ValidationErrorList,
  ValidationErrorItem,
} from './ValidationError.styled';

const ValidationError = ({ messages }) => {
  if (!messages || messages.length === 0) return null;
  return (
    <ValidationErrorWrapper>
      <ValidationErrorTitle>Please fix the following:</ValidationErrorTitle>
      <ValidationErrorList>
        {messages.map((msg, i) => (
          <ValidationErrorItem key={i}>{msg}</ValidationErrorItem>
        ))}
      </ValidationErrorList>
    </ValidationErrorWrapper>
  );
};

export default ValidationError;
